import React from 'react';
import PropTypes from 'prop-types';
import FinderBase from "./FinderBase";
import FinderHeader from "./FinderHeader";
import FinderToolbar from "./FinderToolbar";
import FinderBody from "./FinderBody";
import NavPath from "../NavPath/NavPath";

const LayoutFinder = ({
  backgroundColor,
  expanded,
  title,
  parents,
  filters,
  action,
  views,
  search,
  children,
  onSelect
}) => {
  return React.createElement(FinderBase, {
    backgroundColor: backgroundColor,
    expanded: expanded
  }, React.createElement(FinderHeader, {
    backgroundColor: backgroundColor
  }, React.createElement(NavPath, {
    parents: parents,
    title: title,
    filters: filters,
    search: search,
    onSelect: onSelect
  }), action && React.createElement(FinderToolbar, {
    buttons: action
  })), React.createElement(FinderBody, null, children));
};

LayoutFinder.propTypes = process.env.NODE_ENV !== "production" ? {
  backgroundColor: PropTypes.string,
  expanded: PropTypes.bool,
  title: PropTypes.string,
  parents: PropTypes.array,
  filters: PropTypes.array,
  action: PropTypes.array,
  views: PropTypes.array,
  search: PropTypes.object
} : {};
export default LayoutFinder;